<div class="articles">
    <h6 appLocalizationPopupDirective [localizationCode]="title">
        {{ translate.instant(title) }}
    </h6>
    <div class="navigation-container">
        <ng-container *ngIf="articles.length > 0; else noArticles">
            <button mat-icon-button class="nav-button prev-button" appPreventDoubleClick (throttledClick)="previousCards()"
                [disabled]="currentIndex === 0">
                <mat-icon class="material-icons-outlined">chevron_left</mat-icon>
            </button>

            <div class="cards-viewport">
                <div class="cards-container" [style.transform]="'translateX(' + translateX + 'px)'">
                    <mat-card *ngFor="let article of articles; let i = index" class="article-card"
                        [class.read]="isArticleRead(article)" appPreventDoubleClick
                        (throttledClick)="openArticleDialog(article)">
                        <mat-card-header>
                            <mat-card-title [matTooltip]="article.title" [matTooltipDisabled]="!isTitleTruncated"
                                (mouseenter)="isTitleTruncated = shouldShowTooltip($event)"
                                [matTooltipClass]="'no-ellipsis-tooltip'">{{ article.title }}</mat-card-title>
                            <mat-card-subtitle>{{ article.lastEditedOn | date:'medium' }}</mat-card-subtitle>
                        </mat-card-header>

                        <mat-card-content>
                            <ng-continer *ngIf="article.showImageOnSplashPage && article.titleImage">
                                <ng-container *ngIf="getArticleImageUrl(article) | withLoading | async as articleImage">
                                    <ng-template [ngIf]="articleImage.value">
                                        <img class="article-image" [src]="articleImage.value" [alt]="article.title">
                                    </ng-template>
                                    <ng-template [ngIf]="articleImage.error">
                                        <div class="error-placeholder">Error loading image</div>
                                    </ng-template>
                                    <ng-template [ngIf]="articleImage.loading">
                                        <ngx-skeleton-loader count="1" appearance="square" size="100"></ngx-skeleton-loader>
                                    </ng-template>
                                </ng-container>
                            </ng-continer>

                            <p
                                [ngClass]="{'largeSplashText': article.showImageOnSplashPage === false || article.titleImage === null}">
                                {{ article.splashText }}</p>
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>

            <button mat-icon-button class="nav-button next-button" appPreventDoubleClick (throttledClick)="nextCards()"
                [disabled]="currentIndex >= articles.length">
                <mat-icon class="material-icons-outlined">chevron_right</mat-icon>
            </button>
        </ng-container>
        <ng-template #noArticles>
            <p class="no-articles-text">
                {{ 'NoArticlesAvailable' | translate: {Default: "No articles available."} }}
            </p>
        </ng-template>
    </div>
</div>